module.exports = __webpack_public_path__ + "media/images/svg/facebook-3dd7fde370737fed225cd3ddda9878e7.svg";